import { Flex, Layout } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { AppLayoutSidebarTrigger } from "@/modules/app-layout/app-layout-sidebar-trigger";
import { NavButtonAbout } from "@/modules/nav-button-about";
import { NavButtonLink } from "@/modules/nav-button-link";
import { NavButtonNotifications } from "@/modules/nav-button-notifications";
import { UserDropdownMenu } from "@/modules/user-dropdown-menu";
import { useThemeBreakpoints } from "@/services/theme";
import { AppLogo } from "@/ui/app-logo";

import "./app-layout-header.style.less";

const { Header } = Layout;

export const AppLayoutHeader = () => {
  const { t } = useTranslation();
  const { isXs } = useThemeBreakpoints();

  return (
    <Header className={classNames("stelar-layout-header", { "-xs": isXs })}>
      <Flex align="center" gap="small">
        {isXs && <AppLayoutSidebarTrigger />}
        <AppLogo withLink />
      </Flex>
      <div className="stelar-layout-header-menu">
        <NavButtonNotifications />
        <NavButtonLink linkKey="support" title={t("global:helpCenter.link")} />
        <NavButtonAbout title={t("global:about.title")} />
        <UserDropdownMenu />
      </div>
    </Header>
  );
};
